import { HomeOutlined } from '@ant-design/icons';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui';

export const ResetControl = ({ onChange }) => {
  const { t } = useTranslation();
  const handleReset = useCallback(() => {
    onChange({ reset: true });
  }, [onChange]);

  return (
    <Button data-testid="ol-control-reset" title={t('table.reset', 'Reset')} onClick={handleReset}>
      <HomeOutlined />
    </Button>
  );
};
